(async () => {
    const { Core } = await importModule('Core');
    const { $show } = await importModule('Utils');

    const CN_EXPANDED = '!expanded';
    const EXPAND_THRESHOLD = 130;
    
    customElements.define('product-description-expand', class extends Core {
        elements = {
            content: '[data-content]',
            link: '[data-expand-link]'
        }


        // À la fermeture d'une description longue : si le début du bloc est au-dessus de
        // l'écran (l'utilisateur a défilé), on y remonte, avec la marge de l'en-tête collant.
        scrollToStart() {
            const block = this.closest('[data-meta-block]') || this;
            const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
            const top = block.getBoundingClientRect().top - header - 16;
            if (top >= 0) return;
            const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollBy({ top, behavior: smooth ? 'smooth' : 'instant' });
        }

        render() {
            const contentHeight = this.$content.offsetHeight;
            if(contentHeight > EXPAND_THRESHOLD * 1.25) {
                this.classList.remove(CN_EXPANDED);
                this.style.setProperty('--expand-height', `${EXPAND_THRESHOLD}px`);
                $show(this.$link);
                this.$link.addEventListener('click', () => {
                    this.classList.toggle(CN_EXPANDED);
                    if (!this.classList.contains(CN_EXPANDED)) this.scrollToStart();
                })
            }
        }
    })
})();